import { render } from "./SpeakerCalenders.vue?vue&type=template&id=eed6448e"
import script from "./SpeakerCalenders.vue?vue&type=script&lang=js"
export * from "./SpeakerCalenders.vue?vue&type=script&lang=js"

import "./SpeakerCalenders.vue?vue&type=style&index=0&id=eed6448e&lang=css"

import exportComponent from "C:\\Users\\jason\\Documents\\Saxton-Widgets\\saxton\\saxton-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__